"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectString = exports.Select = void 0;
const mobx_1 = require("mobx");
const light_1 = require("@zajno/common/lazy/light");
const FlagModel_1 = require("./FlagModel");
const Validatable_1 = require("./Validatable");
const wrappers_1 = require("@zajno/common/models/wrappers");
const types_1 = require("@zajno/common/types");
class Select extends Validatable_1.ValidatableModel {
    constructor(items, _accessor, initialIndex = 0) {
        super();
        this._accessor = _accessor;
        this._index = undefined;
        this._indexLocked = false;
        this._initialIndex = null;
        this._flags = (0, light_1.createLazy)(() => this.createFlags());
        this.opened = new FlagModel_1.FlagModel();
        this.setIndex = (val) => {
            if (this._indexLocked) {
                return;
            }
            this._index = val;
            if (this._validateOnChange) {
                this.validate();
            }
            try {
                this._indexLocked = true;
                if (this._flags.hasValue) {
                    this._flags.value.forEach((f, i) => f.value = (i === this._index));
                }
            }
            finally {
                this._indexLocked = false;
            }
        };
        this.reset = () => {
            super.reset();
            this.index = this._initialIndex;
        };
        this._items = items;
        this._initialIndex = initialIndex;
        this._index = initialIndex;
        (0, mobx_1.makeObservable)(this, {
            _index: mobx_1.observable,
            _items: mobx_1.observable.ref,
            values: mobx_1.computed,
            items: mobx_1.computed,
            setIndex: mobx_1.action,
        });
    }
    get valueToValidate() { return this.selectedItem; }
    get values() {
        return this.items.map(i => this._accessor(i));
    }
    get flags() {
        return this._flags.value;
    }
    get items() {
        return types_1.Getter.getValue(this._items);
    }
    get value() { return this.selectedValue; }
    get selectedValue() {
        const vs = this.values;
        return vs.length ? vs[this._index] : null;
    }
    set value(v) { this.selectedValue = v; }
    set selectedValue(value) {
        const index = this.values.indexOf(value);
        if (index >= 0) {
            this.index = index;
        }
    }
    get selectedItem() {
        const items = this.items;
        return items.length ? items[this._index] : null;
    }
    set selectedItem(item) {
        const index = this.items.indexOf(item);
        if (index >= 0) {
            this.index = index;
        }
    }
    get isDefault() { return this._index === this._initialIndex; }
    get index() {
        return this._index;
    }
    set index(val) {
        this.setIndex(val);
    }
    createFlags() {
        const flags = this.items
            .map((item, index) => {
            const flag = (0, wrappers_1.withLabel)(new FlagModel_1.FlagModel(index === this.index), () => this._accessor(item));
            (0, mobx_1.reaction)(() => flag.value, isSelected => {
                if (isSelected) {
                    this.index = index;
                }
            });
            return flag;
        });
        return flags;
    }
}
exports.Select = Select;
class SelectString extends Select {
    constructor(items, initialIndex = 0) {
        super(items, v => v, initialIndex);
    }
}
exports.SelectString = SelectString;
//# sourceMappingURL=SelectModel.js.map